import { Options } from "$fresh/plugins/twind.ts";

export default {
  selfURL: import.meta.url,
  theme: {
    extend: {
      fontFamily: {
        "sans": ["Roboto", "sans-serif"],
      },
    },
  },
} as Options;
